import ComboContent from "./ComboContent";
import ComboItemProductContent from "./ComboItemProductContent";
import ComboUpsellModal from "./ComboUpsellModal";

export default {
  ComboContent,
  ComboItemProductContent,
  ComboUpsellModal,
}